import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const NotificationConfigActionsEdit = ({
  notificationConfig,
  company,
  subcompany,
  t,
  handleClick = () => {},
}) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(
      company.id,
      subcompany.id,
      `notifications_config/${notificationConfig.id}/edit`
    )}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(NotificationConfigActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/actions/NotificationsConfigActionsEdit.js